// useNodeTypeSchemaCacheRefresh.js

import { useCallback } from 'react';

// Firebase
import { db } from 'firebaseConfig';

// Services
import { syncNodeTypeSchemaCacheForWorkspace } from 'services/nodetypes/NodeTypesCacheService';

/**
 * useNodeTypeSchemaCacheRefresh
 *
 * Returns a stable helper that refreshes node type schema cache for a workspace and type key.
 *
 * @returns {function} Cache refresh callback.
 */
export default function useNodeTypeSchemaCacheRefresh() {
  return useCallback(({ workspaceKey, typeKey, fields } = {}) => {
    const normalizedWorkspaceKey = typeof workspaceKey === 'string' && workspaceKey.trim()
      ? workspaceKey.trim()
      : null;

    return syncNodeTypeSchemaCacheForWorkspace(db, {
      workspaceKey: normalizedWorkspaceKey,
      typeKey: typeof typeKey === 'string' ? typeKey.trim() : '',
      fields: Array.isArray(fields) ? fields : null,
      subscribe: false,
      ttlMs: 0,
    })
      .catch((error) => {
        console.warn('Node types cache refresh failed:', error);
      });
  }, []);
}
